// extracted by mini-css-extract-plugin
export default {"root":"LiquidLogo_root__02TRM","svg":"LiquidLogo_svg__dtrxD","liquidRing":"LiquidLogo_liquidRing__wHhau","image":"LiquidLogo_image__Pn+XL"};